import { ValidationRule, ValidationSchemaParsed } from '../../../@types/validation-types'
import { ScreenName } from '../../domain/wizardScreens'
import { REQUIRED_VALIDATORS } from '../rules/validationFunctions'

export const getRequiredFieldsPerScreen = (
  validationSchema: ValidationSchemaParsed,
  screenName: ScreenName
): string[] => {
  const result = [] as string[]
  const screenValidationRule = validationSchema[screenName]
  if (screenValidationRule) {
    Object.entries(screenValidationRule).forEach(([property, allValidationRules]) => {
      if (allValidationRules?.some((rule: ValidationRule) => REQUIRED_VALIDATORS.includes(rule))) {
        result.push(property)
      }
    })
  }
  return result
}
